import React, { Component } from 'react'

import Footer from '../Common/Footer/Footer'
import Header from '../Common/Header/Header'
import SearchHeader from '../Common/SearchHeader/SearchHeader'
import BackgroundSlider from '../Common/BackgroundSlider/BackgroundSlider'
import LoadingBar from 'react-redux-loading-bar'
import LoginBox from '../Common/LoginBox/LoginBox'
import ReduxToastr from 'react-redux-toastr'
import { Helmet } from 'react-helmet'
import InfoNotification from '../Common/InfoNotification/InfoNotification'
import CampaignBox from '../Common/CampaignBox/CampaignBox'

import './Layout/App.css'
import 'react-redux-toastr/lib/css/react-redux-toastr.min.css'
import './Layout/DatePicker.css'

class App extends Component {
  constructor (props) {
    super(props)

    this.state = {
      infoNotifications: [
        {message: 'آموزش من مالک هستم', url: '/page/help-im-an-owner'},
        {message: 'آموزش من یک پرورش دهنده هستم', url: '/page/help-im-a-breeder'},
        {message: 'گزارش اشکال در اطلاعات اسب', url: '/page/help-horse-report'},
        {message: 'آموزش جستجو', url: '/page/help-search'},
        {message: 'آموزش پیشنهاد تغییر در سایت', url: '/page/help-add-new-feature'},
        {message: 'قرار دادن عکس برای اسب', url: '/page/help-image-upload'}
      ],
      infoItem: null,
      showCampaign: new Date().getTime() < new Date('2017-09-10').getTime() // payane eyde ghadir
    }
    this.toggleCampaignPopup = this.toggleCampaignPopup.bind(this)
  }

  toggleCampaignPopup (show = false) {
    this.setState({showCampaign: show})
  }

  componentDidMount () {
    this.setState({infoItem: this.state.infoNotifications[Math.floor(Math.random() * this.state.infoNotifications.length)], showDonate: true})
  }

  render () {
    const { infoItem, showCampaign } = this.state

    if (window.__BROWSER_ENV__) {
      require('../../utils/offlineIndicator').default()
    }
    const location = this.context.router.location.pathname
    return (
      <div id="wrapper">
        <Helmet>
          <title>Iaho</title>
          <meta name="description" content="ایاهو؛ موتور جستجوی اسب اصیل" />
          <meta property="og:title" content="ایاهو" />
          <meta property="og:locale" content="fa_IR" />
          <meta property="og:type" content="website" />
          <meta property="og:site_name" content="موتور جستجوی اسب اصیل" />
          <meta property="og:description" content="نوین‌‌سازی صنعت اسب اصیل" />
          <meta property="og:image" content="https://iaho.ir/MiniLogo.jpg" />
          <meta property="og:url" content="https://iaho.ir/" />
          <meta property="twitter:description" content="نوین‌سازی صنعت اسب اصیل" />
          <meta property="twitter:card" content="ایاهو؛ موتور جستجوی اسب اصیل" />
          <meta name="twitter:image:alt" content="ایاهو | موتور جستجوی اسب اصیل" />
        </Helmet>
        {(location === '/' || location === '/signup' || location === '/login' || location === '/forget-password' || location === '/reset-password') && <BackgroundSlider />}
        <LoadingBar maxProgress={98} style={{ backgroundColor: 'white', height: '4px', zIndex: 9999 }} />
        {(location === '/' || location === '/signup' || location === '/login' || location === '/forget-password' || location === '/reset-password') ? <Header /> : <SearchHeader />}
        <LoginBox />
        {showCampaign && location === '/' && <CampaignBox toggler={this.toggleCampaignPopup} />}
        <ReduxToastr
          timeOut={4000}
          newestOnTop={false}
          preventDuplicates={false}
          position="bottom-right"
          transitionIn="fadeIn"
          transitionOut="fadeOut"
          progressBar
          />

        {(location === '/' && infoItem) &&
        <InfoNotification message={infoItem.message} url={infoItem.url} />
          }

        {this.props.children}
        <Footer location={location} />
      </div>
    )
  }
}

App.contextTypes = {
  router: React.PropTypes.object
}

export default App



// WEBPACK FOOTER //
// ./src/components/App/App.js